<template>
    <div id="userdetail-page" class="mb-5">
        <b-card>
            <b-row>
              <b-col md="12">
              <h3>{{$route.name}}</h3>
              <b-breadcrumb>
                <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
                <b-breadcrumb-item><router-link to="/sales/sales-order">Sales Order</router-link></b-breadcrumb-item>
                <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
              </b-breadcrumb>
              <div class="border-bottom"></div>
             </b-col>
            </b-row>
            <form v-on:submit.prevent="doSubmit" class="mt-3">
              <div>
                <b-row>
                  <b-col md="5">
                    <label class="labels">Order Date *</label>
                    <b-form-datepicker id="orderDate" name="orderDate" v-model="model.orderDate" v-validate="modelValidations.orderDate" v-bind:class="errors.has('orderDate') ? 'is-invalid':''" locale="en-US"
                    ></b-form-datepicker>
                  </b-col>
                  <b-col md="2">
                  </b-col>
                  <b-col md="5">
                    <label class="labels">Note</label>
                    <b-form-textarea name="note" rows="3" placeholder="Enter Note" v-model="model.note" v-bind:class="errors.has('note') ? 'is-invalid':''" :error="errors.first('note')"  />
                  </b-col>
                </b-row>
              </div>
              <hr class="my-4">
              <b-row>
                <b-col md="12 mt-3 mb-3">
                  <h5>Items</h5>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="5">
                  <label class="labels">item *</label>
                  <div class="form-group" v-bind:class="errors.has('item') ? 'has-error':''">
                    <b-form-select name="item" v-model="model.item" v-bind:class="errors.has('item') ? 'is-invalid':''" :error="errors.first('item')" :options="listItem" placeholder="item">
                    </b-form-select>
                  </div>
                </b-col>
                <b-col md="5">
                  <label class="labels">Quantity</label>
                    <b-form-input type="number" name="quantity" rows="3" v-validate="'required'" placeholder="Enter Quantity" v-model="model.quantity" v-bind:class="errors.has('quantity') ? 'is-invalid':''" :error="errors.first('quantity')"  />
                </b-col>
                <b-col md="2 mt-4">
                  <label class="labels"></label>
                  <b-button @click="add()"> Add to list</b-button>    
                </b-col>
              </b-row>
              <!--<input type="text" class="mt-5" v-model="title" placeholder="What you want to do"/>
              <b-button @click="add()"> Add to list</b-button>
              <b-row>
                <b-col v-for="(todo, index) in todos">{{todo}}
                  <b-button @click="remove(index)" variant="danger" class="remove">hapus</b-button>
                </b-col>
              </b-row>-->
              <b-col md="12 mt-5 mb-3">
                <h5>Items</h5>
              </b-col>
              <b-col md="12 mb-5">
                <div class="table-responsive">
                  <table class="table table-hovered table-striped">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Quantity</th>
                      </tr>
                    </thead>
                    <tbody v-if="itemList.length > 0">
                      <tr v-for="(item, index) in itemList" :key="item.uuid">
                        <td>{{item.item.name}}</td>
                        <td>{{item.qtyUsed}}</td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td colspan="9" class="text-center">there's no data</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-col>
              <b-row class="mt-4">
                  <b-col md="6">
                    <b-button variant="secondary" class="btn-back float-left" @click="goBack()"><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button>
                  </b-col>
                  <b-col md="6">
                    <b-button :variant="$route.params.id !== undefined ? 'warning' : 'primary'" class="btn-back float-right" type="submit"><font-awesome-icon icon="save"></font-awesome-icon> {{$route.params.id !== undefined ? 'Update' : 'Save'}} </b-button>
                  </b-col>
                </b-row>
            </form>
        </b-card>
    </div>
</template>

<script>
    export default {
        name: 'sales-order-form',
        props: {
          msg: String
        },
        data () {
          return {
            title: '',
            todos: ["Go to shop"],
            isLoading: false,
            apiUrl: {
              salesOrder: window.AppConfig.apiUrl + 'sales-order', 
            },
            order: {
              uuid: '',
              item: '',
              qtyUsed: ''
            },
            model: {
              item: null,
              quantity: null,
              orderDate: null,
              note: ''
            },
            modelValidations: {  
              orderDate: {
                required: true
              }
            },
            itemList: [],
            listItem: [],
            totalPrice: 0
          }
        },
        mounted () {
          this.initData()
          this.getItem()
        },
        methods: {
          initData () {
            if (this.$route.params.id !== undefined) {
              this.getDetail()
            }
          },
          getDetail () {
            this.isLoading = true
            this.$http.get(this.apiUrl.salesOrder + '/' + this.$route.params.id).then(response => {
              this.model.orderDate = this.$moment(new Date(response.data.orderDate)).format('YYYY-MM-DD')
              this.model.note = response.data.note
              this.order.uuid = response.data.salesOrderItem !== null ? response.data.salesOrderItem[0].uuid : '-'
              this.order.item = response.data.salesOrderItem !== null ? response.data.salesOrderItem[0].item.name : '-'
              this.order.quantity = response.data.salesOrderItem !== null ? response.data.salesOrderItem[0].item.qtyUsed : '-'
              this.itemList = []
              this.totalPrice = 0
              if (response.data.salesOrderItem !== null) {
                response.data.salesOrderItem.forEach(data => {
                  this.totalPrice += Math.round(data.balance)
                  this.itemList.push(data)
                  this.currency = data.item.itemCategory.currency
                })
              }
            })
          },
          doEdit () {
            this.$validator.validateAll().then(res => {
              if (res) {
                this.model.listItem = [
                  {
                    "uuid": this.order.uuid,
                    "item": this.order.item,
                    "qtyUsed": this.order.quantity
                  }
                ]
                let formData = new FormData()
                formData.append('orderDate', this.model.orderDate)
                formData.append('note', this.model.note)
                formData.append('salesOrderItem', JSON.stringify(this.model.listItem))
                if (this.$route.params.id !== undefined) {
                  this.$http.patch(this.apiUrl.salesOrder + '/' + this.$route.params.id, formData).then(response => {
                    this.$store.dispatch('notification/success', 'Item has been updated.')
                    window.location.href = document.URL.replace('/edit', '')
                  }).catch(error => {
                    this.$store.dispatch('notification/error', error)
                  })
                }
              } else {
                swal("", "Please fill the required fields!", "info", {
                  buttons: false,
                  timer: 2000
                });
              }
            })
          },
          getItem () {
            this.$http.get(window.AppConfig.apiUrl + 'item?limit=100').then(response => {
              this.listItem = []
              response.data._embedded.item.forEach(data => {
                  this.listItem.push({
                    value: data.uuid,
                    text: data.name
                  })
              })
            })
          },
          add() {
            if(this.model.quantity !== null){
              this.itemList.unshift(this.model.quantity)
              this.model.quantity = null
            }
          },
          remove(id) {
            this.$delete(this.todos, id)
          },
          getDateTime (value) {
            if (value !== null) {
              return this.$moment(value).format('YYYY-MM-DD HH:mm A')
            } else {
              return '-'
            }
          },
          goBack () {
              window.goBack(this)
          },
          doSubmit () {
            this.$validator.validateAll().then(res => {
              if (res) {
                if (this.$route.params.id !== undefined) {
                  this.$http.patch(this.apiUrl.salesOrder + '/' + this.$route.params.id, this.model).then(response => {
                    this.$store.dispatch('notification/success', 'Sales Order has been updated.')
                    window.location.href = document.URL.replace('/edit', '')
                  }).catch(error => {
                    this.$store.dispatch('notification/error', error)
                  })
                }
              } else {
                swal("", "Please fill the required fields!", "info", {
                  buttons: false,
                  timer: 2000
                });
              }
            })
          }
        }
    }
</script>